"use client";

import Link from "next/link";
import Image from "next/image";
import { usePathname } from "next/navigation";
import { useState } from "react";
import DownloadModal from "../DownloadModal";
import Icon from "./Icon";
import MobileNav from "./MobileNav";

const navLinks = [
  { name: "Home", route: "/" },
  { name: "About", route: "/about" },
  { name: "Contact", route: "/contact-us" },
  { name: "FAQ", route: "/frequently-asked-questions" },
  { name: "Resources", route: "/resources" },
];

const Header: React.FC = () => {
  const pathname = usePathname();
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);

  return (
    <>
      <header className="sticky top-0 z-50 w-full border-b border-gray-100 bg-white">
        <nav className="relative mx-auto flex max-w-[1300px] flex-row items-center justify-between px-5 py-5 lg:px-10">
          <Link href="/">
            <Image
              src="/icons/mobile-logo.svg"
              alt="storytime logo image"
              className="h-[38px] w-[106px] md:hidden"
              width={106}
              height={38}
            />
            <Image
              src="/icons/new-logo-blue.svg"
              alt="storytime logo image"
              className="hidden h-12 w-[108px] md:block"
              width={108}
              height={48}
            />
          </Link>
          <div
            aria-label="navigation links"
            className="hidden flex-row md:flex"
          >
            <ul className="flex flex-1 flex-row items-center gap-x-[27px]">
              {navLinks.map((link) => (
                <li
                  key={link.route}
                  className="hover:text-primary cursor-pointer transition-all duration-200 hover:scale-110 lg:text-xl"
                >
                  <Link
                    className={`font-abezee transition-colors ${
                      pathname === link.route
                        ? "text-primary font-semibold"
                        : ""
                    }`}
                    href={link.route}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <button
            className="bg-primary hover:bg-primary/70 font-abezee hidden cursor-pointer rounded-full px-[40.45px] py-[13.48px] text-center text-white transition-all duration-300 md:flex"
            onClick={() => setIsDownloadModalOpen(true)}
          >
            Download app
          </button>
          <button
            aria-label="Open mobile navigation"
            className="flex items-center justify-center p-2 transition-all duration-300 hover:scale-110 md:hidden"
            onClick={() => setIsMobileNavOpen(true)}
          >
            <Icon name="Menu" color="black" size={28} />
          </button>
        </nav>
      </header>

      <MobileNav
        isOpen={isMobileNavOpen}
        onClose={() => setIsMobileNavOpen(false)}
        navLinks={navLinks}
        onDownloadClick={() => setIsDownloadModalOpen(true)}
      />
      {isDownloadModalOpen && (
        <DownloadModal onClose={() => setIsDownloadModalOpen(false)} />
      )}
    </>
  );
};

export default Header;
